var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userType == 'ADMIN')?_c('div',{staticStyle:{"justify-content":"center","display":"flex","padding-top":"30px","font-weight":"bold","font-size":"24px"}},[_vm._v(" Coming Soon... ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }